let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("j2LWC")).then(() => parcelRequire('3qoCN'));